/**
 * <OwnerEditShareModal> - Iter 9.40 Pass I
 *
 * Card owner can override the share page subtitle for THEIR card.
 * Writes to POST /api/preference-share/:cardId/share-override { subtitle }
 */
import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Pencil } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OwnerEditShareModal({ open, onOpenChange, cardId, initial, onSaved }) {
  const [subtitle, setSubtitle] = useState("");

  useEffect(() => {
    if (open) setSubtitle(initial || "");
  }, [open, initial]);

  const save = async () => {
    const res = await fetch(`${API}/preference-share/${cardId}/share-override`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("session_token")}` },
      body: JSON.stringify({ subtitle }),
    });
    if (res.ok) {
      toast.success("Share text updated");
      onSaved?.(subtitle);
      onOpenChange?.(false);
    } else {
      toast.error("Failed to update");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="owner-edit-share-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <Pencil className="w-4 h-4 text-purple-500" /> Customize share text
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Subtitle shown in the purple hero</Label>
            <Input
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              placeholder='e.g. "What my favorite MUA should know"'
              data-testid="owner-edit-subtitle-input"
              maxLength={80}
            />
            <p className="text-[10px] text-gray-400 mt-1">{subtitle.length}/80</p>
          </div>
          <Button className="w-full" onClick={save} data-testid="owner-edit-save">Save</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
